import SearchDefaults from "./app-config-search";

let sessionData = {
  searchCriterias: null
};

(function () {
  const JOOMLA_VARS = Joomla.getOptions('com_kurortlife.options');
  const storageKey = JOOMLA_VARS.cookieKeyForSearchCriterias;

  const cookies = document.cookie
    .split(';')
    .map(c => c.trim().split('='))
    .reduce((obj, [key, value]) => {
      obj[key] = value;
      return obj;
    }, {});

  console.log('app-ctx-cookies: cookies = ', document.cookie);
  const searchCriteriasB64 = cookies[storageKey];

  function computeDefaultSearchCriterias() {
    // compute default check-in / check-out dates
    const today = new Date();
    const nextMondayDate = new Date(
      today.getTime() + (1 - today.getDay() + 7) * 24 * 60 * 60 * 1000
    );
    const differenceInDays = Math.ceil(
      Math.abs(nextMondayDate - today.getTime()) / (1000 * 60 * 60 * 24)
    );
    const checkInDate =
      differenceInDays <= 3
        ? new Date(nextMondayDate.setDate(nextMondayDate.getDate() + 7))
        : nextMondayDate;
    const nextFriday = new Date(checkInDate);
    nextFriday.setDate(nextFriday.getDate() + 4);

    const dateRangeDefault = {
      checkInDate,
      checkOutDate: nextFriday
    };

    // return default search criterias
    return {
      occupacyValue: { adults: 2, children: 1 },
      dietaryValue: SearchDefaults.dietaryTreatmentSettings.dietaryOptions[0],
      dateRangeValue: dateRangeDefault
    };
  }

  /**
   * Normalizes a URL-encoded Base64 string and decodes it.
   * @param {string} input - The Base64 string (potentially URL encoded)
   */
  function decodeBase64WithUrlPadding(input) {
      let normalized = input;

      // 1. Convert URL-encoded padding (%3D) back to '='
      if (normalized.endsWith('%3d%3d') || normalized.endsWith('%3D%3D')) {
          normalized = normalized.slice(0, -6) + '==';
      } else if (normalized.endsWith('%3d') || normalized.endsWith('%3D')) {
          normalized = normalized.slice(0, -3) + '=';
      }

      return atob(normalized);
  }

  let parsed = null;
  if (searchCriteriasB64) {
    let searchCriteriasStr = null;
    try {
      searchCriteriasStr = decodeBase64WithUrlPadding(searchCriteriasB64);
    } catch (e) {
      console.error('app-ctx-cookies: Decoding searchCriterias (atob) failed. Base64 value:', searchCriteriasB64, 'Error:', e);
    }

    try {
      parsed = JSON.parse(searchCriteriasStr);
    } catch (e) {
      console.error('app-ctx-cookies: Parsing searchCriterias JSON failed. JSON string:', searchCriteriasStr, 'Error:', e);
    }
  }

  if (parsed && typeof parsed === 'object') {
    sessionData.searchCriterias = parsed;
  } else {
    console.log('app-ctx-cookies: Using default search criterias');
    sessionData.searchCriterias = computeDefaultSearchCriterias();
  }
})();

export default sessionData;
